import React, { useEffect, useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import styled from 'styled-components';
import ProtectedRoute from './Components/ProtectedRoute';
import Login from './Pages/Login';
import { initializeLiff, getAndStoreLineData, isLoggedIn as isLineLoggedIn, loginWithLine } from './services/lineService';
import OTPPage from './Pages/OTPPage';
import SuccessPage from './Pages/SuccessPage';
import RegisterStep1 from './Pages/register/re-1';
import RegisterStep2 from './Pages/register/re-2';
import WelcomePage from './Pages/WelcomePage';
import DailyHealthRecord from './Pages/DailyHealthRecord';
import DashboardPage from './Pages/DashboardPage'
import VaccineNotificationPage from './Pages/VaccineNotificationPage';
import BloodPressurePage from './Pages/BloodPressurePage';
import BloodSugarPage from './Pages/BloodSugarPage';
import WeightPage from './Pages/WeightPage';
import TestResultsPage from './Pages/TestResultsPage';
import ComparisonResultsPage from './Pages/ComparisonResultsPage';
import HospitalCheckupForm from './Pages/HospitalCheckupForm';
import ProfileEditPage from './Pages/ProfileEditPage';
import RecommendationsPage from './Pages/RecommendationsPage';
import NotificationsPage from './Pages/NotificationsPage';
import XrayResultsPage from './Pages/XrayResultsPage';
import UrineTestResultsPage from './Pages/UrineTestResultsPage';
import StoolTestResultsPage from './Pages/StoolTestResultsPage';
import KidneyPage from './Pages/KidneyPage';
import CBCPage from './Pages/CBCPage';
import HbA1cPage from './Pages/HbA1cPage';
import LipidPage from './Pages/LipidPage';
import LiverPage from './Pages/LiverPage';
import UricAcidPage from './Pages/UricAcidPage';
import PublicHealthBookPage from './Pages/PublicHealthBookPage';

const AppContainer = styled.div`
  min-height: 100vh;
  font-family: 'Noto Sans Thai', sans-serif !important;
  font-weight: bold;
  background-color: white;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: bold;
  }
`;

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/otp",
    element: <OTPPage />,
  },
  {
    path: "/success",
    element: <SuccessPage />,
  },
  {
    path: "/register",
    element: <RegisterStep1 />,
  },
  {
    path: "/register/step1",
    element: <RegisterStep1 />,
  },
  {
    path: "/register/step2",
    element: <RegisterStep2 />,
  },
  {
    path: "/welcome",
    element: <ProtectedRoute><WelcomePage /></ProtectedRoute>,
  },
  {
    path: "/daily-health-record",
    element: <ProtectedRoute><DailyHealthRecord /></ProtectedRoute>,
  },
  {
    path: "/dashboard",
    element: <ProtectedRoute><DashboardPage /></ProtectedRoute>,
  },
  {
    path: "/vaccine-notification",
    element: <ProtectedRoute><VaccineNotificationPage /></ProtectedRoute>,
  },
  {
    path: "/blood-pressure",
    element: <ProtectedRoute><BloodPressurePage /></ProtectedRoute>,
  },
  {
    path: "/blood-sugar",
    element: <ProtectedRoute><BloodSugarPage /></ProtectedRoute>,
  },
  {
    path: "/weight",
    element: <ProtectedRoute><WeightPage /></ProtectedRoute>,
  },
  {
    path: "/test-results",
    element: <ProtectedRoute><TestResultsPage /></ProtectedRoute>,
  },
  {
    path: "/comparison-results",
    element: <ProtectedRoute><ComparisonResultsPage /></ProtectedRoute>,
  },
  {
    path: "/hospital-checkup",
    element: <ProtectedRoute><HospitalCheckupForm /></ProtectedRoute>,
  },
  {
    path: "/profile-edit",
    element: <ProtectedRoute><ProfileEditPage /></ProtectedRoute>,
  },
  {
    path: "/recommendations",
    element: <ProtectedRoute><RecommendationsPage /></ProtectedRoute>,
  },
  {
    path: "/notifications",
    element: <ProtectedRoute><NotificationsPage /></ProtectedRoute>,
  },
  {
    path: "/xray-results",
    element: <ProtectedRoute><XrayResultsPage /></ProtectedRoute>,
  },
  {
    path: "/urine-test-results",
    element: <ProtectedRoute><UrineTestResultsPage /></ProtectedRoute>,
  },
  {
    path: "/stool-test-results",
    element: <ProtectedRoute><StoolTestResultsPage /></ProtectedRoute>,
  },
  {
    path: "/kidney",
    element: <ProtectedRoute><KidneyPage /></ProtectedRoute>,
  },
  {
    path: "/cbc",
    element: <ProtectedRoute><CBCPage /></ProtectedRoute>,
  },
  {
    path: "/hba1c",
    element: <ProtectedRoute><HbA1cPage /></ProtectedRoute>,
  },
  {
    path: "/lipid",
    element: <ProtectedRoute><LipidPage /></ProtectedRoute>,
  },
  {
    path: "/liver",
    element: <ProtectedRoute><LiverPage /></ProtectedRoute>,
  },
  {
    path: "/uric-acid",
    element: <ProtectedRoute><UricAcidPage /></ProtectedRoute>,
  },
  {
    path: "/public-healthbook",
    element: <PublicHealthBookPage />,
  }

], {
  basename: "/"
});

function App() {
  const [liffInitialized, setLiffInitialized] = useState(false);
  const [liffError, setLiffError] = useState(null);

  useEffect(() => {
    const initLiff = async () => {
      try {
        // ตรวจสอบว่าเป็น public route หรือไม่
        const isPublicRoute = window.location.pathname === '/public-healthbook';

        console.log('🚀 Initializing LIFF...');
        console.log('📍 Current URL:', window.location.href);

        // ตรวจสอบว่ามี session อยู่แล้วหรือไม่ (ลองทั้ง localStorage และ sessionStorage)
        const tokenFromLocal = localStorage.getItem('token') || localStorage.getItem('userToken');
        const tokenFromSession = sessionStorage.getItem('token') || sessionStorage.getItem('userToken');
        const userDataFromLocal = localStorage.getItem('userData');
        const userDataFromSession = sessionStorage.getItem('userData');

        const hasToken = tokenFromLocal || tokenFromSession;
        const hasUserData = userDataFromLocal || userDataFromSession;

        console.log('🔍 Session check:', {
          localStorage: { token: !!tokenFromLocal, userData: !!userDataFromLocal },
          sessionStorage: { token: !!tokenFromSession, userData: !!userDataFromSession },
          hasToken: !!hasToken,
          hasUserData: !!hasUserData
        });

        // ถ้ามีใน sessionStorage แต่ไม่มีใน localStorage ให้ restore
        if (tokenFromSession && !tokenFromLocal) {
          console.log('🔄 Restoring token from sessionStorage to localStorage');
          localStorage.setItem('token', tokenFromSession);
          localStorage.setItem('userToken', tokenFromSession);
        }
        if (userDataFromSession && !userDataFromLocal) {
          console.log('🔄 Restoring userData from sessionStorage to localStorage');
          localStorage.setItem('userData', userDataFromSession);
        }

        const success = await initializeLiff();

        if (success) {
          setLiffInitialized(true);
          console.log('✅ LIFF initialized successfully');

          // ถ้าเป็น public route ไม่ต้องบังคับ login
          if (isPublicRoute) {
            console.log('Public route detected, skipping auto-login');
            return;
          }

          // ถ้า login แล้ว ให้ดึงข้อมูล LINE
          if (isLineLoggedIn()) {
            console.log('✅ User is logged in to LINE');
            const lineData = await getAndStoreLineData();
            if (lineData) {
              console.log('LINE User ID:', lineData.lineUserId);
              console.log('LINE Display Name:', lineData.displayName);
            }

            // ถ้ามี session อยู่แล้ว ไม่ต้องทำอะไร
            if (hasToken && hasUserData) {
              console.log('✅ Existing session found, user is already authenticated');
              console.log('📍 Current path:', window.location.pathname);
            }
          } else {
            console.log('⚠️ User is not logged in to LINE, initiating login...');
            // ถ้ายังไม่ได้ login ให้ login อัตโนมัติ
            loginWithLine();
          }
        } else {
          setLiffError('Failed to initialize LIFF');
        }
      } catch (error) {
        console.error('❌ LIFF init error:', error);
        setLiffError(error.message);
      }
    };

    initLiff();
  }, []);

  // ถ้าเป็น public route ไม่ต้องรอ LIFF initialization
  const isPublicRoute = window.location.pathname === '/public-healthbook';

  // แสดง loading ขณะ LIFF กำลัง initialize (แต่ skip สำหรับ public route)
  if (!liffInitialized && !liffError && !isPublicRoute) {
    return (
      <AppContainer style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <p>กำลังเชื่อมต่อ LINE...</p>
        </div>
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      <RouterProvider router={router} />
    </AppContainer>
  );
}

export default App;